var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-switch-component d-flex align-items-center",class:{ 'normal-style': !_vm.radius, 'radius-style': _vm.radius }},_vm._l((_vm.options),function(item,index){return _c('button',{key:index,staticClass:"btn btn-block m-0",class:{
      'btn-outline-secondary': _vm.value !== item.value,
      'btn-primary': _vm.value === item.value,
      'slim-size': _vm.slim,
      'radius-style': _vm.radius
    },attrs:{"type":"button","name":("button-switch-" + (item.value))},on:{"click":function($event){return _vm.$emit('input', item.value)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }